import { BaseModel } from "./base/base.model";

export class AppSeccion extends BaseModel {
  section1!: string;
  company?: String;
  org?: String;
  name?: String;
  parent?: String;
  validator?: string;
  validatorName?: string;
  validatorPosition?: string;
  validatorProfileImage?: {
    imageData: string,
    mimeType: string
  };
  dualResponsible?: string;
  dualResponsibleName?: string;
  dualResponsiblePosition?: string;
  delegateResponsible?: string;
  delegateResponsibleName?: string;
  delegateResponsiblePosition?: string;
  delegateResponsibleAllow?: string;
  dualResponsibleAllow?: string;
}
